import React from 'react';
import './Footer.css';

const Footer = ({ isDarkMode }) => {
  return (
    <footer data-theme={isDarkMode ? 'dark' : 'light'}>
      <div className="footer-content">
        <p>made with <span className="love">❤</span> by Vedant Supnekar</p>
        <ul className="nav__links footer_navlink">
          <li><a href="mailto:vedant.supnekar@gmail.com">vedant.supnekar@gmail.com</a></li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
